module.exports = __webpack_public_path__ + "img/die-mobiliar@2x.e3e0a4d.png";